/**
 * Postcode fields formatting library.
 */
(function($) {

  const formatOptions = {
    translation: {
      'N': {pattern: /\d/},
      'L': {pattern: /[a-zA-Z]/}
    },
    onKeyPress: function(cep, event, currentField, options) {
      const upperCase = currentField.val().toUpperCase();
      currentField.val(upperCase);
    },
  };

  const postCodeFormat = $('.postcode-field').attr('data-format');
  if(postCodeFormat) {
    $('.postcode-field').mask(postCodeFormat, formatOptions);
  };

})(jQuery);